export default __webpack_public_path__ + "static/media/content-development.cf50d9b1.png";